export const INITIAL_VALUES = {
  office_id: '',
  group_for: null,
};
